import * as React from "react";
import { ItactTableContainer } from "../containers/tablecontainers/ItactTableContainer";
import { AppLayout } from "./AppLayout";

export const ItactScreen = () => {
    return (
        <AppLayout>
            <ItactTableContainer/>
        </AppLayout>
    );
};
